export const mimeTypes = {
  json: 'application/json',
  csv: 'text/plain',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
};
